{
  "header": {
    "nameShowStaticText": true,
    "nameStaticText": "Used Model: OPC 40084-9",
    "modelShowStaticText": false,
    "modelVariable": {
      "id": "39dc5ed4-8612-4c49-8a64-98979cb114fd",
      "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/Extrusion_v2/GeneralTypes/",
      "nodeId": "ns=1;i=6661",
      "displayName": "Model",
      "variablePath": "Identification.Model",
      "dataType": "LocalizedText",
      "valueRank": -1,
      "modellingRule": "Mandatory",
      "hasProperties": false
    }
  },
  "imagesConfig": {
    "imageDefaults": {
      "[\\s\\S]*": "pr_opc40084-9.jpg"
    }
  },
  "timeline": {
    "variable": {
      "id": "941384d6-f645-4c47-8b47-d33d9c8c328a",
      "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/Extrusion_v2/GeneralTypes/",
      "nodeId": "ns=1;i=6682",
      "displayName": "CurrentState",
      "variablePath": "MachineryBuildingBlocks.MachineryItemState.CurrentState",
      "dataType": "LocalizedText",
      "valueRank": -1,
      "modellingRule": "Mandatory",
      "hasProperties": true
    },
    "colorValues": {
      "Executing": "#00ff00",
      "NotAvailable": "#c8c8c8",
      "OutOfService": "#ff0000",
      "NotExecuting": "#ffff00"
    }
  },
  "sections": [
    {
      "isPlaceholder": false,
      "title": "Identification",
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Machine Type",
              "showAsLink": false,
              "valueVariable": {
                "id": "37e4873c-235c-4b12-830c-abe61239ae56",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/Extrusion_v2/GeneralTypes/",
                "nodeId": "ns=1;i=6656",
                "displayName": "DeviceClass",
                "variablePath": "Identification.DeviceClass",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Manufacturer",
              "showAsLink": false,
              "valueVariable": {
                "id": "6c5e95b6-241d-49ee-aa4a-dc878ad07686",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/Extrusion_v2/GeneralTypes/",
                "nodeId": "ns=1;i=6652",
                "displayName": "Manufacturer",
                "variablePath": "Identification.Manufacturer",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Model",
              "showAsLink": false,
              "valueVariable": {
                "id": "39dc5ed4-8612-4c49-8a64-98979cb114fd",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/Extrusion_v2/GeneralTypes/",
                "nodeId": "ns=1;i=6661",
                "displayName": "Model",
                "variablePath": "Identification.Model",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Serial Number",
              "showAsLink": false,
              "valueVariable": {
                "id": "09d54023-2946-487e-b54d-0ca68f87e822",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/Extrusion_v2/GeneralTypes/",
                "nodeId": "ns=1;i=6653",
                "displayName": "SerialNumber",
                "variablePath": "Identification.SerialNumber",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            }
          ]
        }
      ]
    },
    {
      "isPlaceholder": false,
      "title": "Monitoring",
      "rows": [
        {
          "isPlaceholder": true,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Length",
              "showAsLink": false,
              "valueVariable": {
                "id": "d29097b1-c6cb-4efc-af79-962b8f71ae45",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/Extrusion_v2/Cutter/",
                "nodeId": "ns=1;i=6026",
                "displayName": "Length",
                "variablePath": "Length",
                "dataType": "Double",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": true,
                "hasUnit": true,
                "hasRange": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Total Output",
              "showAsLink": false,
              "valueVariable": {
                "id": "01374887-0346-4102-8403-2a635d290f03",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/Extrusion_v2/Cutter/",
                "nodeId": "ns=1;i=6038",
                "displayName": "TotalOutput",
                "variablePath": "TotalOutput",
                "dataType": "UInt64",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false,
                "hasUnit": false,
                "hasRange": false
              }
            }
          ],
          "placeholderObject": "CuttingProducts.CuttingProduct_<Nr>.[PLACEHOLDER]",
          "placeholderConditionType": {
            "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/Extrusion_v2/Cutter/",
            "nodeId": "ns=1;i=1003",
            "displayName": "CuttingProductType",
            "typeDefinition": "nsu=http://opcfoundation.org/UA/PlasticsRubber/Extrusion_v2/Cutter/;i=1003",
            "subTypes": []
          },
          "titleVariable": {
            "id": "52383c2d-f07a-46ba-9a6f-c280a58c6822",
            "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/Extrusion_v2/Cutter/",
            "nodeId": "ns=1;i=6034",
            "displayName": "Id",
            "variablePath": "Id",
            "dataType": "String",
            "valueRank": -1,
            "modellingRule": "Mandatory",
            "hasProperties": false
          }
        }
      ]
    }
  ]
}
